import { Tooltip } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { stringify } from 'qs';
import * as React from 'react';

import { trackShareButtonClickClick } from './tracking';
import { ShareButton } from '../../components/ShareButton';
import { useTrackingParams } from '../../hooks/useTrackingParams';
import { EPageType } from '../../types/page/pageType';
import { isNavigatorShareSupported } from '../../utils/isNavigatorShareSupported';
import { useGetShareButtonText } from '../../hooks/useGetShareButtonText';

interface IShareButtonContainerProps {
  isEndPage?: boolean;
}

export const ShareButtonContainer: React.FC<IShareButtonContainerProps> = ({ isEndPage }) => {
  const [tooltipOpen, setTooltipOpen] = React.useState<boolean>(false);
  const isDesktop = useIsDesktop();
  const buttonText = useGetShareButtonText();
  const { siteType, dealType, cianSource } = useTrackingParams();

  const setTooltipTextVisible = React.useCallback((isVisible: boolean) => {
    setTooltipOpen(isVisible);
  }, []);

  const onClickHandler = React.useCallback(() => {
    const label = isEndPage ? 'TellEndPage' : 'TellStartPage';
    trackShareButtonClickClick({
      label,
      siteType,
      dealType,
      cianSource,
    });

    const { protocol, host, pathname } = window.location;
    const queryString = stringify({ dealtype: EPageType.Homeowner }, { addQueryPrefix: true, skipNulls: true });
    const url = `${protocol}//${host}${pathname}${queryString}`;

    if (!isDesktop && isNavigatorShareSupported()) {
      window.navigator.share({
        title: 'Онлайн-договор аренды',
        url,
      });
    } else {
      window.navigator.clipboard.writeText(url);
      setTooltipTextVisible(true);
      setTimeout(() => setTooltipTextVisible(false), 1500);
    }
  }, [isDesktop, setTooltipTextVisible]);

  if (!buttonText) {
    return null;
  }

  return (
    <Tooltip title="Ссылка скопирована" open={tooltipOpen} placement="bottom">
      <div>
        <ShareButton onClick={onClickHandler} text={buttonText} />
      </div>
    </Tooltip>
  );
};

ShareButtonContainer.displayName = 'ShareButtonContainer';
